import { get } from 'lodash';
import type { ComponentTypes, DictionaryType } from 'types/story';

export function getText(dictionary: DictionaryType, componentType: ComponentTypes, property: string) {
	return get(dictionary, `${componentType}.${property}`, 'None');
}
